<template>
    <el-dialog :visible.sync="detailDialog" width="52%" center :close-on-click-modal = false :modal-append-to-body = true
               :close-on-press-escape = false top="8vh" @close = "closeDialog" :append-to-body = true v-loading="loading"
               element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-card>
            <div style="height: 700px; overflow: auto">
                <el-row :gutter="20" style="float:right;margin-left:400px;position:absolute;z-index:5">
                      <el-col :span="8" style="width:500px;display:block;margin:0">
                        <el-button  style="background-color:#8A2BE2;margin: 0;width:80px;color:#fff"
                                    @click="remarkOrderDialog = true,remarkOrderRequest.orderId = detail.orderId,remarkOrderRequest.remark = detail.remark">标注</el-button>
                        <el-button  style="background-color:#cd5c5c;margin: 0;width:80px;color:#fff"
                                    @click="freeOrder(detail.orderId)">免单</el-button>
                          <el-button :disabled="detail.state != '0'" style="background-color:#2ECCFA;margin: 0;width:80px;color:#fff"
                          @click="stopOrder(detail.orderId)">暂停</el-button>
                          <el-button :disabled="detail.state != '0'" style="background-color:#FE2E2E;margin: 0;width:130px;color:#fff"
                          @click="forceEndOrderDialog = true,forceEndOrderRequest.orderId = detail.orderId">强制结束</el-button>
                          <el-button :disabled="detail.state === '-1' || detail.state === '-2' || detail.state === '-3'
                          || detail.state === '0' || detail.state === '3'" style="background-color:#00FF00;margin: 0;width:80px;color:#fff"
                          @click="refundDialog = true,refundRequest.orderId = detail.orderId">退款</el-button>
                    </el-col>
                </el-row>
                <el-tabs v-model="tabs" type="card">
                    <el-tab-pane label="订单信息" name="1">
                        <el-form ref="dateForm" label-width="85px" label-position="left" v-model="detail">
                            <el-row :gutter="20">
                                  <el-divider content-position="left">用户信息</el-divider>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item label="用户昵称">
                                        <span>{{detail.nickName}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="用户手机号">
                                        <span>{{detail.phone}}</span>
                                     </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                  <el-divider content-position="left">订单信息</el-divider>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item label="订单号">{{detail.orderId}}</el-form-item>
                                    <el-form-item label="创建时间">{{detail.rentTime | formatDate}}</el-form-item>
                                    <el-form-item label="订单单价">{{detail.unitPrice}}</el-form-item>
                                    <el-form-item label="实付金额">{{detail.realPayment}}</el-form-item>
                                    <el-form-item label="租借类型">{{detail.rentTypeStr}}</el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="租借时长">{{detail.duration}}</el-form-item>
                                    <el-form-item label="支付时间"><span v-if="detail.payTime != null">{{detail.payTime | formatDate}}</span></el-form-item>
                                    <el-form-item label="封顶价格">{{detail.maxPrice}}</el-form-item>
                                    <el-form-item label="优惠金额">{{detail.discountMoney}}</el-form-item>
                                    <el-form-item label="优惠方式">{{detail.discountTypeStr}}</el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="订单状态">{{detail.stateStr}}</el-form-item>
                                    <el-form-item label="押金类型"></el-form-item>
                                    <el-form-item label="订单金额">{{detail.orderMoney}}</el-form-item>
                                    <el-form-item label="最终金额">{{detail.finalMoney}}</el-form-item>
                                    <el-form-item label="支付方式">{{detail.assStr}}</el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                  <el-divider content-position="left">租借信息</el-divider>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item label="商户编号">
                                        <span>{{detail.rentBsCode}}</span>
                                    </el-form-item>
                                    <el-form-item label="门店名称">
                                        <span>{{detail.rentStoreName}}</span>
                                    </el-form-item>
                                    <el-form-item label="门店联系人">
                                        <span>{{detail.rentStoreContact}}</span>
                                    </el-form-item>
                                    <el-form-item label="槽位数">{{detail.rentSlot}}</el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="商户名称">
                                        <span>{{detail.rentBsName}}</span>
                                    </el-form-item>
                                    <el-form-item label="门店地区">
                                        <span>{{detail.rentArea}}</span>
                                    </el-form-item>
                                    <el-form-item label="联系电话">
                                        <span>{{detail.rentStoreContactPhone}}</span>
                                    </el-form-item>
                                    <el-form-item label="小宝编号">{{detail.powerBankId}}</el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="门店编号">
                                        <span>{{detail.rentStoreCode}}</span>
                                    </el-form-item>
                                    <el-form-item label="门店地址">
                                        <span>{{detail.rentAddress}}</span>
                                     </el-form-item>
                                    <el-form-item label="设备编号">{{detail.rentPowerBoxId}}</el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                  <el-divider content-position="left">归还信息</el-divider>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item label="商户编号">
                                        <span>{{detail.returnBsCode}}</span>
                                    </el-form-item>
                                    <el-form-item label="门店名称">
                                        <span>{{detail.returnStoreName}}</span>
                                    </el-form-item>
                                    <el-form-item label="门店联系人">
                                        <span>{{detail.returnStoreContact}}</span>
                                    </el-form-item>
                                    <el-form-item label="槽位数">{{detail.returnSlot}}</el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="商户名称">
                                        <span>{{detail.returnBsName}}</span>
                                    </el-form-item>
                                    <el-form-item label="门店地区">
                                        <span>{{detail.returnArea}}</span>
                                    </el-form-item>
                                    <el-form-item label="联系电话">
                                        <span>{{detail.returnStoreContactPhone}}</span>
                                    </el-form-item>
                                    <el-form-item label="小宝编号">{{detail.powerBankId}}</el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="门店编号">
                                        <span>{{detail.returnStoreCode}}</span>
                                    </el-form-item>
                                    <el-form-item label="门店地址">
                                        <span>{{detail.returnAddress}}</span>
                                     </el-form-item>
                                    <el-form-item label="设备编号">{{detail.returnPowerBoxId}}</el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="设备信息" name="2">
                        <el-form  ref="dateForm" label-width="85px" label-position="left" v-model="detail">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item label="代理名称">
                                        <span>{{detail.csName}}</span>
                                    </el-form-item>
                                    <el-form-item label="代理性质">
                                        <span>{{detail.csType}}</span>
                                    </el-form-item>
                                    <el-form-item label="BD名称">
                                        <span>{{detail.bdName}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="代理电话">
                                        <span>{{detail.csPhone}}</span>
                                     </el-form-item>
                                     <el-form-item label="代理地区">
                                        <span>{{detail.csArea}}</span>
                                    </el-form-item>
                                    <el-form-item label="BD电话">
                                        <span>{{detail.bdPhone}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>

                    </el-tab-pane>
                    <el-tab-pane label="运维信息" name="3">
                        <el-table :data="detail.cooOrderMaintenanceDtoList" height=500 border :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                            <el-table-column label="操作类型" prop="type" align="center"></el-table-column>
                            <el-table-column label="状态" prop="state" align="center"></el-table-column>
                            <el-table-column label="原因" prop="reason" align="center"></el-table-column>
                            <el-table-column label="操作时间" align="center">
                                <template slot-scope="scope">{{scope.row.createTime |formatDate}}</template>
                            </el-table-column>
                            <el-table-column label="操作人" prop="comUserName" align="center"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                  <el-tab-pane label="退款信息" name="4">
                    <el-table :data="detail.cooOrderRefundDtoList" height=500 border :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                      <el-table-column label="退款单号" prop="refundId" align="center"></el-table-column>
                      <el-table-column label="退款金额" prop="refundMoney" align="center"></el-table-column>
                      <el-table-column label="退款状态" prop="refundState" align="center"></el-table-column>
                      <el-table-column label="退款原因" prop="refundReason" align="center"></el-table-column>
                      <el-table-column label="退款时间" prop="refundTime" align="center"></el-table-column>
                    </el-table>
                  </el-tab-pane>
                </el-tabs>
            </div>
        </el-card>
        <el-dialog :visible.sync="forceEndOrderDialog" width="40%" :append-to-body=true  top="20vh" center v-loading="loading"  element-loading-text="网络请求中" element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0.8, 0, 0, 0.3)" :close-on-click-modal = false :close-on-press-escape = false  title="强制结束"
               :show-close=false @close="closeForceEndDialog">
            <el-card style="border: 1px solid #01DFD7">
                 <el-form ref="form" v-model="forceEndOrderRequest" label-position="left">
                    <el-form-item label="结束原因"><el-input type="textarea" :rows="2" placeholder="结束原因" v-model="forceEndOrderRequest.reason" style="width:220px"> </el-input></el-form-item>
                    <el-form-item label="结束时间">
                          <el-date-picker v-model="forceEndOrderRequest.endTime" type="datetime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
                    </el-form-item>
                 </el-form>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button style="background-color:#A9F5F2;margin: 0" @click="forceEndOrder">确认</el-button>
                <el-button style="background-color:#A9F5A9;margin: 0" @click="forceEndOrderDialog = false">取消</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="refundDialog" width="40%" :append-to-body=true  top="20vh" center v-loading="loading"  element-loading-text="网络请求中" element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0.8, 0, 0, 0.3)" :close-on-click-modal = false :close-on-press-escape = false  title="退款"
               :show-close=false @close="closeRefundDialog">
            <el-card style="border: 1px solid #01DFD7">
                 <el-form ref="form" v-model="forceEndOrderRequest" label-position="left">
                     <el-form-item label="可退金额">{{detail.finalMoney}}</el-form-item>
                    <el-form-item label="结束原因"><el-input type="textarea" :rows="2" placeholder="结束原因" v-model="refundRequest.reason" style="width:220px"> </el-input></el-form-item>
                    <el-form-item label="退款金额"><el-input type="text" :rows="2" placeholder="退款金额" v-model="refundRequest.refundMoney" style="width:220px"> </el-input></el-form-item>
                 </el-form>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button style="background-color:#A9F5F2;margin: 0" @click="refund">确认</el-button>
                <el-button style="background-color:#A9F5A9;margin: 0" @click="refundDialog = false">取消</el-button>
            </span>
        </el-dialog>
      <el-dialog :visible.sync="remarkOrderDialog" width="40%" :append-to-body=true  top="20vh" center v-loading="loading"  element-loading-text="网络请求中" element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(0.8, 0, 0, 0.3)" :close-on-click-modal = false :close-on-press-escape = false  title="订单标注"
                 :show-close=false @close="closeRemarkOrderDialog">
        <el-card style="border: 1px solid #01DFD7">
          <el-form ref="form" v-model="remarkOrderRequest" label-position="left">
            <el-form-item label="标注内容"><el-input type="textarea" :rows="2" placeholder="请输入标注内容" value="remarkOrderRequest.remark == null,'':remarkOrderRequest.remark" v-model="remarkOrderRequest.remark" style="width:420px"> </el-input></el-form-item>
          </el-form>
        </el-card>
        <span slot="footer" class="dialog-footer">
                <el-button style="background-color:#A9F5F2;margin: 0" @click="remarkOrder">确认</el-button>
                <el-button style="background-color:#A9F5A9;margin: 0" @click="remarkOrderDialog = false">取消</el-button>
            </span>
      </el-dialog>
    </el-dialog>
</template>

<script>
import {getOrderInfo, remarkOrder, freeOrder,stopOrder, refund, forcedEnd} from '../../api/oder/powerbankorder.js'
import {formatDate} from "../../utils/date";
export default {
    data() {
        return {
            tabs: '1',
            detailDialog: false,
            loading: false,
            detail: '',
            forceEndOrderDialog: false,
            refundDialog: false,
            remarkOrderDialog: false,
            orderId: '',
            forceEndOrderRequest: {
                orderId: '',
                reason: '',
                endTime: ''
            },
            refundRequest: {
                orderId: '',
                reason: '',
                refundMoney: ''
            },
            remarkOrderRequest: {
            orderId: '',
            remark: ''
          }
        }
    },
    methods: {
        init(value){
            this.loading = true;
            this.orderId = value;
            this.$nextTick(() => {
                this.detailDialog = true;
                getOrderInfo(value).then(result=>{
                    this.detail = result.data
                    this.loading = false;
                })
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.tabs = "1";
            this.detail = "";
        },

      /**
       * 订单免单
       */
      freeOrder(value){
        this.loading = true;
        this.$msgbox({
          title: "操作确认",
          message: "确定要执行免单操作吗？",
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              freeOrder({'orderId':value.toString()});
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
              });
            }
            done();
          }
        });
        this.loading = false;
      },

        /**
         * 暂停订单
         */
        stopOrder(value){
            this.loading = true;
            stopOrder({'orderId':value.toString()});
            this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
            this.loading = false;
        },

        /**
         * 强制结束订单
         */
        forceEndOrder(){
            this.loading = true;
            forcedEnd(this.forceEndOrderRequest);
            this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
            this.loading = false;
            this.forceEndOrderDialog = false;
            init(this.orderId);
        },

        /**
         * 退款
         */
        refund(){
            if(Number(this.refundRequest.refundMoney) * 100 <= 0){
                this.$message({
                    message: "退款金额必须大于0",
                    type: "error",
                    duration: 1500,
                });
                return;
            }
            if(Number(this.refundRequest.refundMoney) * 100 > Number(this.detail.finalMoney) * 100){
                this.$message({
                    message: "退款金额超过可退金额",
                    type: "error",
                    duration: 1500,
                });
                return;
            }
            this.refundRequest.refundMoney = this.refundRequest.refundMoney * 100;
            refund(this.refundRequest);
            this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                });
            this.refundDialog = false;
            init(this.orderId);
        },

      /**
       * 标注
       */
      remarkOrder(){
        remarkOrder(this.remarkOrderRequest);
        this.$message({
          message: "操作成功",
          type: "success",
          duration: 1500,
        });
        this.remarkOrderDialog = false;
        init(this.orderId);
      },
        /**
         * 关闭退款弹窗
         */
        closeRefundDialog(){
            this.refundRequest.orderId = "";
            this.refundRequest.reason = "";
            this.refundRequest.refundMoney = "";
            this.refundDialog = false;
        },

      /**
       * 关闭退款弹窗
       */
      closeRemarkOrderDialog(){
        this.remarkOrderRequest.orderId = "";
        this.remarkOrderRequest.remark = "";
        this.remarkOrderDialog = false;
      },
        /**
         * 关闭强制结束弹窗
         */
        closeForceEndDialog(){
            this.forceEndOrderRequest.orderId = "";
            this.forceEndOrderRequest.reason = "";
            this.forceEndOrderRequest.endTime = "";
            this.forceEndOrderDialog = false;
        }
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ordermanagement/orderDetail.vue